module.exports = require("@swa-ui/itinerary/src/FlightNumbers/FlightNumbers.module.scss");